import { newSpecPage } from '@stencil/core/testing'
import { CobaltBanner } from '../cobalt-banner'

describe('cobalt-banner', () => {
  it('should render default banner element', async () => {
    const page = await newSpecPage({
      components: [CobaltBanner],
      html: '<cobalt-banner message="message" headline="headline"></cobalt-banner>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-banner headline="headline" message="message">
        <core-banner dismissbuttonlabel="Fermer" headline="headline" message="message" status="information"></core-banner>
      </cobalt-banner>
    `)
  })
})
